export * from './src/stores-catalog-v3-ribbon-ribbons-v-3.meta.js';
